import { render, staticRenderFns } from "./OptimizerManagerCreate.vue?vue&type=template&id=b804a29a&scoped=true"
import script from "./OptimizerManagerCreate.vue?vue&type=script&lang=js"
export * from "./OptimizerManagerCreate.vue?vue&type=script&lang=js"
import style0 from "./OptimizerManagerCreate.vue?vue&type=style&index=0&id=b804a29a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b804a29a",
  null
  
)

export default component.exports